// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InfoTooltip__trigger":"bcp_a big_jb big_qx big_eg"};